import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { USER_ROLE_ADMIN } from 'common/userRoles';
import setNullEmptyValues from 'common/util/setNullEmptyValues';

import { pickAssemblyLineApplicationEditableFields } from 'server/models/AssemblyLineApplication/fieldgroups';

import { SCREEN_ID_APPLICATION_ASSEMBLY_LINE } from 'client/constants/screenIds';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedRoles from 'client/helpers/allowedRoles';
import AssemblyLineActions from 'client/actions/AssemblyLine';
import HouseholdActions from 'client/actions/Household';
import SrApplicationAssemblyLine from 'client/components/SrApplicationAssemblyLine/SrApplicationAssemblyLine';

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_APPLICATION_ASSEMBLY_LINE)
@withScrollToTop
@branch((props) => ({
  currentUser: ['currentUser'],
  assemblyLine: ['assemblyLine', 'byHouseholdListings', props.match.params.householdListingId],
  listingsApplyingFor: [
    'household',
    'listingsApplyingFor',
    'byHouseholdListingId',
    props.match.params.householdListingId,
  ], // eslint-disable-line max-len
}))
class ApplicationAssemblyLinePage extends Component {
  static fetchData(match, inject) {
    if (match.params.householdListingId) {
      return Promise.all([
        HouseholdActions.getListingsApplyingFor(inject, {
          householdListingId: parseInt(match.params.householdListingId, 10),
        }),
        AssemblyLineActions.loadAssemblyLineData(inject, {
          householdListingId: parseInt(match.params.householdListingId, 10),
          reload: true,
        }),
      ]);
    }
  }

  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    assemblyLine: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
  };

  static getPageMetadata = () => ({
    pageTitle: 'Application Assembly Line | Sunroom Rentals',
  });

  _reloadAssemblyLineData = () => {
    const { match, dispatch } = this.props;

    return Promise.all([
      dispatch(HouseholdActions.getListingsApplyingFor, {
        householdListingId: parseInt(match.params.householdListingId, 10),
      }),
      dispatch(AssemblyLineActions.loadAssemblyLineData, {
        householdListingId: parseInt(match.params.householdListingId, 10),
        reload: true,
      }),
    ]);
  };

  _startAssemblyLineApplication = ({ householdApplicationId }) => {
    const { assemblyLine, dispatch } = this.props;

    return dispatch(AssemblyLineActions.startAssemblyLineApplication, {
      householdApplicationId,
      listingId: assemblyLine.listing.id,
    });
  };

  _updateAssemblyLineApplication = ({ assemblyLineApplicationId, updates }) => {
    const { assemblyLine, dispatch } = this.props;

    return dispatch(AssemblyLineActions.updateAssemblyLineApplication, {
      assemblyLineApplicationId,
      listingId: assemblyLine.listing.id,
      updates: setNullEmptyValues(pickAssemblyLineApplicationEditableFields(updates)),
    });
  };

  render() {
    const { dispatch, currentUser, assemblyLine, listingsApplyingFor } = this.props;

    if (!assemblyLine) {
      return <div className="loading-gif" />;
    }

    return (
      <SrApplicationAssemblyLine
        dispatch={dispatch}
        currentUser={currentUser}
        assemblyLine={assemblyLine}
        listingsApplyingFor={listingsApplyingFor || []}
        reloadAssemblyLineData={this._reloadAssemblyLineData}
        startAssemblyLineApplication={this._startAssemblyLineApplication}
        updateAssemblyLineApplication={this._updateAssemblyLineApplication}
      />
    );
  }
}

ApplicationAssemblyLinePage.displayName = 'ApplicationAssemblyLinePage';

export default ApplicationAssemblyLinePage;
